import * as React from "react";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { observer, inject } from "mobx-react";
import { UitkCard } from "uitk-react-cards";
import { LobFormWithTabs } from "src/components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs.tsx";

export interface TabbedWizardCardProps {
  wizardState: ClientWizardStateStore;
  wizardFormChildren: React.ReactElement[];
  wrappingClassNames?: string;
  cardClassNames?: string;
  cardContentClassNames?: string;
  tabGroupClassNames?: string;
  wizardFormClassNames?: string;
}

/**
 * Returns a tabbed wizard within a uitk-card
 * Padding/styling of elements within card are handed down by parent region
 * Assumes any non-wizard form children are handled by parent region
 */
export const TabbedWizardCard: React.FunctionComponent<TabbedWizardCardProps> = inject("wizardState")(
  observer((props: TabbedWizardCardProps) => {
    if (!props.wizardState) {
      return null;
    }

    const wrappingClassNames = props.wrappingClassNames ? props.wrappingClassNames : "";
    const cardClassNames = props.cardClassNames ? props.cardClassNames : "";
    const cardContentClassNames = props.cardContentClassNames ? props.cardContentClassNames : "";
    const tabGroupClassNames = props.tabGroupClassNames ? props.tabGroupClassNames : "";
    const wizardFormClassNames = props.wizardFormClassNames ? props.wizardFormClassNames : "";

    return (
      <div className={`wizardCard ${wrappingClassNames}`}>
        <UitkCard className={cardClassNames}>
          <div className={cardContentClassNames}>
            <LobFormWithTabs
              lobForms={props.wizardFormChildren}
              wizardFormClassNames={wizardFormClassNames}
              tabGroupClassNames={tabGroupClassNames}
            />
          </div>
        </UitkCard>
      </div>
    );
  })
);
